import {
  FETCH_HEADQUARTER,
  UPDATE_HEADQUARTER_PROFILE,
  UPDATE_ALL_COMPANIES_PROFILES
} from "../actions/headquarter";

export const initialState = {};

const headquarter = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_HEADQUARTER.RESOLVED:
      return payload;
    case UPDATE_HEADQUARTER_PROFILE.RESOLVED:
    case UPDATE_ALL_COMPANIES_PROFILES.RESOLVED:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

export default headquarter;
